/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ClassroomdisciplineClassModules200,
  PostApiV1ClassroomdisciplineClassModules400,
  PostApiV1ClassroomdisciplineClassModules401,
  PostApiV1ClassroomdisciplineClassModules500,
  PostApiV1ClassroomdisciplineClassModulesMutationRequest,
  PostApiV1ClassroomdisciplineClassModulesMutationResponse,
} from "../../types/classPlanningClassModuleController/PostApiV1ClassroomdisciplineClassModules.ts";
import { classModuleDetailViewModelSchema } from "../classModuleDetailViewModelSchema.ts";
import { saveClassModuleViewModelSchema } from "../saveClassModuleViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1ClassroomdisciplineClassModules200Schema = z.lazy(
  () => classModuleDetailViewModelSchema,
) as unknown as ToZod<PostApiV1ClassroomdisciplineClassModules200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ClassroomdisciplineClassModules400Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineClassModules400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ClassroomdisciplineClassModules401Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineClassModules401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ClassroomdisciplineClassModules500Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineClassModules500>;

export const postApiV1ClassroomdisciplineClassModulesMutationRequestSchema =
  z.lazy(
    () => saveClassModuleViewModelSchema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineClassModulesMutationRequest>;

export const postApiV1ClassroomdisciplineClassModulesMutationResponseSchema =
  z.lazy(
    () => postApiV1ClassroomdisciplineClassModules200Schema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineClassModulesMutationResponse>;
